/** "Instrument[]" -> { base: "Instrument", suffix: "[]" } */
function splitType(type) {
  const m = /^(.*?)(\[\])?$/.exec(type);
  return { base: m[1], suffix: m[2] || "" };
}

/**
 * Response-field table. Types come from the schema; there are no descriptions to show.
 * A type that names one of the schema's models links to its block in the Data types section.
 */
export function ApiFieldTable({ fields, typeNames }) {
  if (!fields || fields.length === 0) return null;
  const renderType = (f) => {
    const { base, suffix } = splitType(f.type);
    const nullable = f.nullable ? " · nullable" : "";
    if (typeNames && typeNames.has(base)) {
      return (
        <>
          <a className="apiTypeLink" href={`#type-${base}`}>{base}</a>
          {suffix}
          {nullable}
        </>
      );
    }
    return `${f.type}${nullable}`;
  };
  return (
    <table className="apiTable">
      <thead>
        <tr>
          <th className="apiTableColName">Field</th>
          <th>Type</th>
        </tr>
      </thead>
      <tbody>
        {fields.map((f) => (
          <tr key={f.name}>
            <td><span className="apiParamName">{f.name}</span></td>
            <td><span className="apiParamType">{renderType(f)}</span></td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
